/**
 * Le voci della bozza come le mostra la console (pure, con la loro prova): l'ordine di «Cambiano prezzo» (prima chi
 * cambia di più), la chiave del motivo da tradurre, e cosa il listino nuovo dice di un prodotto da verificare.
 */
import type { MotivoDaVerificare, VoceDelConfronto, VociDelConfronto } from '../../services/listiniFornitoriService';

const variazione = (v: VoceDelConfronto) => (v.prima ? Math.abs(((v.dopo ?? v.prima) - v.prima) / v.prima) : 0);

/** Aumentati e scesi insieme, prima chi cambia di più in percentuale. */
export function vociCheCambiano(voci: VociDelConfronto): VoceDelConfronto[] {
  return [...voci.aumentati, ...voci.scesi].sort((a, b) => variazione(b) - variazione(a));
}

const CHIAVE_DEL_MOTIVO: Record<MotivoDaVerificare, 'codice' | 'piu_prezzi' | 'soglia'> = {
  codice_cambiato: 'codice',
  piu_prezzi: 'piu_prezzi',
  oltre_soglia: 'soglia',
};

/** La chiave di `bozza.motivi.*`; `null` per le versioni che hanno solo il testo (`perche`). */
export function chiaveDelMotivo(v: VoceDelConfronto): 'codice' | 'piu_prezzi' | 'soglia' | null {
  return v.motivo ? CHIAVE_DEL_MOTIVO[v.motivo] ?? null : null;
}

/** Cosa c'è nel listino nuovo per un prodotto da verificare: i codici simili coi loro prezzi, o i prezzi trovati. */
export function cosaHaTrovato(v: VoceDelConfronto, euro: (n: number) => string): string {
  if (v.candidati?.length) return v.candidati.map((c) => `${c.codice} ${c.prezzi.map(euro).join(' / ')}`).join('; ');
  if (v.prezzi_trovati?.length) return v.prezzi_trovati.map(euro).join(' / ');
  return (v.trovati ?? []).join('; ');
}
